import Large from './Large';
import Medium from './Medium';
import Small from './Small';

const Headline = {
  Large,
  Medium,
  Small
};
export default Headline;